<div class="bl-afs-review bl-wrapper">
  <h1 class="bl-generate-analysis__title"><b>Validate Action Plan</b></h1>
  <br />
  <br />
  <div>
    <div>
      <div class="col-md-10 col-sm-12 bl-afs-review__group-data-wrapper">
        <div class="bl-afs-review__group-data">
          <span>Operation number:</span>
          <span class="bl-afs-review__group-data--strong-letter">{{
            analysisData?.operationNumber
          }}</span>
        </div>
      </div>
      <div class="col-md-10 col-sm-12 bl-afs-review__group-data-wrapper">
        <div class="bl-afs-review__group-data">
          <span>Loan number: </span>
          <span class="bl-afs-review__group-data--strong-letter">{{
            analysisData?.loanNumber
          }}</span>
        </div>
        <div class="bl-afs-review__group-data">
          <span>Audit Period: </span>
          <span class="bl-afs-review__group-data--strong-letter"
            >{{ analysisData?.initDate.toString() | slice:0:10 }} - {{ analysisData?.endDate.toString() | slice:0:10 }}</span
          >
        </div>
        <div class="bl-afs-review__group-data">
          <span>Project name: </span>
          <span class="bl-afs-review__group-data--strong-letter">{{
            analysisData?.projectName
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <div>
    <bid-update-action-plan-table
      *ngIf="analysisData?.testResults"
      [headerTable]="headerTUAP"
      [bodyTable]="analysisData?.testResults"
    >
    </bid-update-action-plan-table>
  </div>
</div>
